import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-[#1f222d] text-slate-300 mt-20">
      <div className="max-w-7xl mx-auto px-4 lg:px-8 py-14 grid grid-cols-2 md:grid-cols-4 gap-8">
        <div className="col-span-2 md:col-span-1">
          <img src="/isbul-logo.png" alt="isbul.org" className="h-12 w-auto object-contain bg-white rounded-lg p-1.5 mb-4" />
          <p className="text-sm text-slate-400 leading-relaxed">
            Türkiye'nin yeni nesil, yapay zeka destekli iş bulma ve iş verme platformu.
          </p>
        </div>
        <div>
          <h4 className="font-semibold text-white mb-4">İş Arayanlar</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/ilanlar" className="hover:text-white transition-colors">İş İlanları</Link></li>
            <li><Link to="/ai-eslestirme" className="hover:text-white transition-colors">AI İş Eşleştirme</Link></li>
            <li><Link to="/kayit" className="hover:text-white transition-colors">CV Oluştur</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-semibold text-white mb-4">İşverenler</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/kayit" className="hover:text-white transition-colors">İlan Yayınla</Link></li>
            <li><Link to="/sirketler" className="hover:text-white transition-colors">Şirketler</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-semibold text-white mb-4">Kurumsal</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/ilanlar" className="hover:text-white transition-colors">Kategoriler</Link></li>
            <li><a href="/api/sitemap.xml" className="hover:text-white transition-colors">Site Haritası</a></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10 py-5 text-center text-sm text-slate-500">
        © {new Date().getFullYear()} isbul.org — Tüm hakları saklıdır.
      </div>
    </footer>
  );
}
